import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "../SpaceDialogAction";
import { DialogStudentNotificationContent } from "../DialogStudentNotification";

const DialogDeleteStudentSuccessfully = ({
	dialog, space, studentsSelectedToUse
}) => {
	const props = studentsSelectedToUse.length === 1
		? {
			title: `Se eliminó a ${studentsSelectedToUse[0].id} (${studentsSelectedToUse[0].name}) de la reserva del espacio ${space.name}`,
			content: "Recuerda que al eliminar un alumno, podrás agregarlo nuevamente a esta u otra reserva desde el botón agregar alumno(s)."
		}
		: {
			title: `Se eliminó a los alumnos(as) de la reserva del espacio ${space.name}`,
			contentComponent:
				<DialogStudentNotificationContent
					description={
						<>
							Recuerda que al eliminar un alumno, podrás agregarlo nuevamente a esta u otra reserva desde el botón agregar alumno(s).<br /><br />
							Alumnos(as) eliminados(as):
						</>
					}
					students={studentsSelectedToUse}/>
		};
	return (
		<SpaceDialogAction
			dialog={dialog}
			{...props}>
			<CustomButton
				width="120px"
				text="Cerrar"
				onClick={dialog.hide} />
		</SpaceDialogAction>
	);
}

export default DialogDeleteStudentSuccessfully;